import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UserCompetency } from 'app/_models/competency.model';
import { CompetencyCardType } from 'app/components/competency-card/competency-card.component';

@Component({
  selector: 'toc-competency-row',
  templateUrl: './toc-competency-row.component.html',
})
export class TocCompetencyRowComponent implements OnChanges {
  @Input() competencies: UserCompetency[] = [];
  @Input() cardType: CompetencyCardType = 'user-readonly';

  public showAllCompetencies = true;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.competencies) {
      this.showAllCompetencies = true;
    }
  }

  public toggleCompetencies() {
    this.showAllCompetencies = !this.showAllCompetencies;
  }
}
